import hasSelectedProject from './hasSelectedProject';
import getSelectedProject from './getSelectedProject';

export default function getBackgroundColor() {
    const selectedProject = hasSelectedProject() ? getSelectedProject() : undefined;
    return selectedProject ? selectedProject.backgroundColor : '';
}
